import { NgModule } from "@angular/core";
import { CalendarEventFilesComponent } from "./calendar-event-files.component";
import { CommonModule } from "@angular/common";

@NgModule({
    declarations: [CalendarEventFilesComponent],
    imports: [
        CommonModule
    ]
})

export class CalendarEventFileModule{}


// WEBPACK FOOTER //
// ./src/app/calendar-event-files/calendat-event-file.module.ts